import React, { useState, useEffect } from "react";

// components
import {
  Card,
  CardHeader,
  CardBody,
  Container,
  Row,
  Col,
  Button,
  Spinner
} from "reactstrap";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import MaterialTable from 'material-table';
import Header from "../../../components/Headers/Header.jsx";

// style
import "../../../assets/css/loading.css";

// services
import { showMessage } from "../../../services/message.js";
import { api_GET } from "../../../services/api_service.js";

// views
import PontosColetaForm from '../../../views/admin/coleta/PontosColetaForm.jsx';

//Constants
import { table_translate, table_style } from "../../../constants/MaterialTable.js";


export default function PontosColetaList({ history }) {

  const [showLoading, setshowLoading] = useState(false);

  const [list_table, set_list_table] = useState([])
  const [list_loading, set_list_loading] = useState(false);

  const [showDetail, setshowDetail] = useState(false);
  const [itemDetail, setitemDetail] = useState(null);

  const GetList = () => {
    set_list_loading(true);

    api_GET('pontocoleta').then(result => {
      set_list_loading(false);
      if (result.status !== 200) {
        showMessage("Aviso", result.message, 'error', null);
      }
      else {
        set_list_table(result.data);
      }
    });
  }

  const Edit = (event, rowData) => {
    setshowLoading(true);
    api_GET(`pontocoleta/${rowData.pontoColetaId}`).then(result => {
      setshowLoading(false);
      if (result.status !== 200) {
        showMessage("Aviso", result.message, 'error', null);
      }
      else {
        setshowDetail(true);
        setitemDetail(result.data);
      }
    });
  }

  const Add = () => {
    setitemDetail(null);
    setshowDetail(true);
  };

  useEffect(() => {
    GetList();
  }, []);


  const columnsProp = [
    { title: 'Área Operacional', field: 'areaOperacional' },
    { title: 'Bairro', field: 'bairro' },
    { title: 'Endereço', field: 'endereco' },
    { title: 'Categoria', field: 'categoria' },
    { title: 'Identificação', field: 'identificacao' },
    { title: 'Modalidade de Serviço', field: 'modalidades' },
    { title: 'Status', field: 'status' }
  ]

  return (
    <>
      {showLoading &&
        <div className="carregandoCmp">
          <div className="box">
            <label style={{ marginRight: "20px" }}>Carregando...</label>
            <Spinner size="sm" color="info" />
          </div>
        </div>
      }
      <Header />
      <Container className="mt--9" fluid>

        {!showDetail &&
          <Row>
            <Container className="mt-1" fluid>
              <Card className="shadow">
                <CardHeader className="border-0">
                  <Row>
                    <Col md="6">
                      <strong> Locais de Execução</strong>
                    </Col>
                    <Col md="6" className="text-right">
                      <Button color="primary" type="submit" onClick={() => Add()}>
                        <FontAwesomeIcon icon={faPlus} />  Novo Local de Execução
                      </Button>
                    </Col>
                  </Row>
                </CardHeader>
                <CardBody>
                  <Row>
                    <Col md="12">
                      <MaterialTable
                        title="Lista de Locais de Execução"
                        columns={columnsProp}
                        data={list_table}
                        isLoading={list_loading}
                        options={{ ...table_style, pageSize: 20, pageSizeOptions: [20, 50, list_table.length] }}
                        actions={[
                          {
                            icon: 'edit',
                            tooltip: 'Editar Registro',
                            onClick: (event, rowData) => Edit(event, rowData)
                          }
                        ]}
                        localization={table_translate}
                      />
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Container>
          </Row>
        }

        {showDetail &&
          <PontosColetaForm
            item={itemDetail}
          />
        }

      </Container>

    </>
  );
}
